<template>
	<v-card hover justify-content='center' color="primary" dark :to="to" :outlined="outlined" class='nav-card pa-4' elevation="5" :href='href' :target='_blank ? "_blank" : ""'>
		<v-list-item two-line style="height: 100%">
			<v-list-item-avatar>
				<v-icon v-if="icon" color='secondary' large v-text='icon' />
			</v-list-item-avatar>
			<v-list-item-content>
				<v-list-item-title class='text-wrap' v-text='title' />
				<v-list-item-subtitle class='text-wrap'  v-text="subTitle" />
			</v-list-item-content>
		</v-list-item>
	</v-card>
</template>

<script>
export default {
	props: {
		title: String,
		icon: String,
		subTitle: String,
		linkTo: String,
		_blank: Boolean,
		outlined: Boolean
	},
	computed: {
		href() {
			return this._blank ? this.linkTo : undefined
		},
		to() {
			return this._blank ? undefined : this.linkTo
		}
	}
}
</script>

<style lang="sass" scoped>
.nav-card
	height: 100%
	width: 100%
</style>